import {
    GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS,
    GETALLOCATEDMODULELISTFORSUBADMIN_FAILED,
    RESET_GETALLOCATEDMODULELISTFORSUBADMIN,
    LOADING_GETALLOCATEDMODULELISTFORSUBADMIN,
    NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN,
} from "../types/index";


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETALLOCATEDMODULELISTFORSUBADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETALLOCATEDMODULELISTFORSUBADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETALLOCATEDMODULELISTFORSUBADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
